import styled, { css } from 'styled-components';

import { IconWrapper } from '@dreryk/react-components';

export const StyledAddContinuouslyUsedMedicineIconWrapper = styled(IconWrapper)`
   ${(props) =>
      props.disabled &&
      css`
         fill: ${props.theme.disabledLighter};
      `}
`;

StyledAddContinuouslyUsedMedicineIconWrapper.displayName = 'StyledAddContinuouslyUsedMedicineIconWrapper';
